import { MAGENTO_URL } from '../../config/client.config';

const LEGACY_CART = `${MAGENTO_URL}/checkout/cart`;
const LEGACY_CHECKOUT = `${MAGENTO_URL}/checkout`;

export { LEGACY_CART, LEGACY_CHECKOUT };
